import React from "react";
import { fmtNum } from "@finance/lib/api";

export function FulfillmentKpis({ data, importOutstanding }) {
  const L = data?.line_items || [];
  const sum = (k) => L.reduce((s, l) => s + Number(l[k] || 0), 0);
  const ord = sum("qty_ordered");
  const pct = ord ? Math.round((sum("qty_invoiced") / ord) * 100) : 0;
  const landed = L.reduce((s, l) => s + Number(l.landed_unit_cost || 0) * Number(l.qty_received || l.qty_ordered || 0), 0);
  const tiles = [
    ["Received", `${fmtNum(sum("qty_received"))} / ${fmtNum(ord)}`],
    ["Delivered", `${fmtNum(sum("qty_delivered"))} / ${fmtNum(ord)}`],
    ["Invoiced", `${pct}%`],
    ["Landed cost (TZS, excl. recoverable VAT)", fmtNum(landed)],
    ["Import costs outstanding (TZS)", importOutstanding == null ? "—" : fmtNum(importOutstanding)],
    ["GP (TZS)", fmtNum(data?.total_gp || 0)],
  ];
  return (
    <div className="mb-4 grid grid-cols-2 gap-2 md:grid-cols-3 xl:grid-cols-6" data-testid="fulfillment-kpis">
      {tiles.map(([l, v], i) => (
        <div key={l} className="min-w-0 rounded-lg border border-gray-200 bg-white px-3 py-2 dark:border-[#243049] dark:bg-[#111a2e]" data-testid={`ful-kpi-${i}`}>
          <div className="truncate text-[10px] font-semibold uppercase tracking-wide text-gray-500" title={l}>{l}</div>
          <div className={`truncate font-display font-bold lx-num ${String(v).length > 14 ? "text-sm" : "text-lg"} ${i === 5 && (data?.total_gp || 0) < 0 ? "text-red-600" : "text-gray-900 dark:text-white"}`}>{v}</div>
        </div>
      ))}
    </div>
  );
}
